window._pagesLoaded = []
const _infiniteScrollData = document.querySelector(".infinite-scroll__data")
const _infiniteScrollTotalPages = _infiniteScrollData ? _infiniteScrollData.querySelector("input[data-total-pages]") : null;
if (_infiniteScrollTotalPages) {
    const _numPages = parseInt(_infiniteScrollData.querySelector("input[data-total-pages]").value)
    if (_numPages > 1) {
        window._pagesLoaded[0] = true
        for (let i = 1; i <= _numPages; i++) {
            window._pagesLoaded[i] = false
        }
    }
}

const resetInfiniteScroll = () => {
    window._pagesLoaded = []
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

window.resetInfiniteScroll = resetInfiniteScroll

const sortBy = document.querySelector("select[name='sort_by']");
if (sortBy) {
  sortBy.addEventListener('change', () => {
    window.resetInfiniteScroll()
  })
}

const loadItems = (target) => {
  const totalPages = parseInt($("[data-total-pages]").val())
  let currentPage = parseInt($("[data-current-page]").val())
  
  const nextPage = currentPage + 1
  const nextUrl = $("[data-next-url]").val().replace(/page=[0-9]+/, "page=" + nextPage)
  const updatedNextUrl = $("[data-next-url]").val().replace(/page=[0-9]+/, "page=" + nextPage)

  if (_pagesLoaded[currentPage]) return
  _pagesLoaded[currentPage] = true

  $("[data-current-page]").val(currentPage)
  target.setAttribute("disabled", "")
  target.classList.add("loading")

  $.ajax({
    url: nextUrl,
    type: "GET", 
    dataType: "html",
    success: function(response) {
      $(".load-more-grid").append($(response).find(".load-more-grid").html())
      colorSwatches()
      currentPage += 1
    },
    error: function(error) {
      _pagesLoaded[currentPage] = false
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const infiniteScrollData = document.querySelector(".infinite-scroll__data")
        
        if (infiniteScrollData && currentPage != totalPages) {
          infiniteScrollData.querySelector("input[data-next-url]").dataset.nextUrl = updatedNextUrl
          infiniteScrollData.querySelector("input[data-next-url]").value = updatedNextUrl
          infiniteScrollData.querySelector("input[data-current-page]").dataset.currentPage = currentPage
          infiniteScrollData.querySelector("input[data-current-page]").value = currentPage
        }

        target.removeAttribute("disabled")
        target.classList.remove("loading")

        if (currentPage == totalPages) {
          target.remove()
        }
      }
    }
  })
}

const checkVisibility = () => {
  document.querySelectorAll(".js-infinite-scroll").forEach(target => {
    new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadItems(target)
        }
      })
    }).observe(target)
  })
}

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach(button => {
    button.onclick = () => {
      loadItems(button)
    }
  })
  checkVisibility()
}

loadMore()